{
  "Approved {when}": "אושר {when}",
  "Approved": "אושר",
  "Approved, {n} tasks created": "אושר, נוצרו {n} מעקבים",
  "Call notes aren't switched on for this platform yet.": "סיכומי שיחה עדיין לא מופעלים בפלטפורמה הזו.",
  "Call notes": "סיכומי שיחה",
  "Choose a recording": "בחירת הקלטה",
  "Choose an audio recording: m4a, mp3, wav, ogg, webm or amr.": "בחרו הקלטת אודיו: m4a,‏ mp3,‏ wav,‏ ogg,‏ webm או amr.",
  "Contact linked": "איש הקשר קושר",
  "Contact": "איש קשר",
  "Delete recording": "מחיקת ההקלטה",
  "Delete this recording, its transcript and its summary? Tasks already created stay.": "למחוק את ההקלטה, התמלול והסיכום? מעקבים שכבר נוצרו יישארו.",
  "Follow-ups from the call": "משימות להמשך מהשיחה",
  "Link a contact to turn follow-ups into tasks.": "קשרו איש קשר כדי להפוך משימות להמשך למעקבים.",
  "No contact linked": "לא קושר איש קשר",
  "No name": "ללא שם",
  "No recordings yet": "עדיין אין הקלטות",
  "Pick a call recording from your phone or computer (up to {n} MB). It is transcribed and summarized in your template, and nothing is sent to the customer.": "בחרו הקלטת שיחה מהטלפון או מהמחשב (עד {n} MB). היא מתומללת ומסוכמת בתבנית שלכם, ושום דבר לא נשלח ללקוח.",
  "Ready to review": "מוכן לבדיקה",
  "Recording deleted": "ההקלטה נמחקה",
  "Recordings": "הקלטות",
  "Retry": "ניסיון חוזר",
  "Save changes": "שמירת השינויים",
  "Save template": "שמירת התבנית",
  "Search by name or phone": "חיפוש לפי שם או טלפון",
  "Start from the default": "להתחיל מברירת המחדל",
  "Summarizing…": "מסכם…",
  "Summary template": "תבנית הסיכום",
  "Summary": "סיכום",
  "The audio is deleted after {n} days; the transcript and summary stay until you delete the recording.": "האודיו נמחק אחרי {n} ימים; התמלול והסיכום נשמרים עד שמוחקים את ההקלטה.",
  "The recording is larger than {n} MB.": "ההקלטה גדולה מ-{n} MB.",
  "The sections you want in every call summary, one per line. Left empty, summaries use the default shown in the box.": "החלקים שתרצו בכל סיכום שיחה, אחד בכל שורה. אם השדה ריק, הסיכומים משתמשים בברירת המחדל שמופיעה בו.",
  "The upload failed. Try again.": "ההעלאה נכשלה. נסו שוב.",
  "Ticked follow-ups become tasks on the contact when you approve.": "משימות מסומנות יהפכו למעקבים על איש הקשר כשתאשרו.",
  "Transcribing…": "מתמלל…",
  "Transcript": "תמלול",
  "Trying again": "מנסה שוב",
  "Upload a call recording; get a summary in your template to review and approve": "מעלים הקלטת שיחה ומקבלים סיכום בתבנית שלכם לבדיקה ולאישור",
  "Upload a recording above. Its summary appears here when it is ready, usually within a minute or two.": "העלו הקלטה למעלה. הסיכום יופיע כאן כשיהיה מוכן, בדרך כלל תוך דקה או שתיים.",
  "Upload a recording": "העלאת הקלטה",
  "Uploaded. Transcribing now.": "הועלה. מתמלל עכשיו.",
  "Uploading…": "מעלה…",
  "Waiting": "ממתין",
  "Working on it. This page updates by itself.": "עובדים על זה. הדף מתעדכן לבד.",
  "Recording calls, and telling the other side, is your business's responsibility.": "הקלטת שיחות, ויידוע הצד השני, באחריות העסק.",
  "Manual": "ידני",
  "Automatic, contacts only": "אוטומטי, אנשי קשר בלבד",
  "Automatic, all calls": "אוטומטי, כל השיחות",
  "Automatic upload from this phone:": "העלאה אוטומטית מהטלפון הזה:",
  "Change": "שינוי",
  "Zoom connected": "Zoom חובר",
  "Zoom connection failed": "החיבור ל-Zoom נכשל",
  "Zoom recordings": "הקלטות Zoom",
  "Cloud recordings of your Zoom meetings arrive in Call notes on their own, summarized in your template. Needs a Zoom plan with cloud recording.": "הקלטות הענן של פגישות ה-Zoom שלכם מגיעות לסיכומי שיחה מעצמן, מסוכמות בתבנית שלכם. נדרשת חבילת Zoom עם הקלטה בענן.",
  "Reconnect Zoom": "חיבור מחדש ל-Zoom",
  "Connect Zoom": "חיבור Zoom"
}
